module.exports = __webpack_public_path__ + "img/IMG_2614_T_L.4fea0d57.webp";